import { fromPromise } from 'xstate';

import { inferPetitionScopeLocation } from '#src/app/pages/startAPetitionV2/shared/api';

import type { OperationDeps } from '../types';

import type { Input, Output } from './types';

/** The scope/location inference operation: one `inferPetitionScopeLocation` call, run by the orchestrator's region. */
export const createLogic = ({ utilityContext, track }: Pick<OperationDeps, 'utilityContext' | 'track'>) =>
	fromPromise<Output, Input>(async ({ input }) => inferPetitionScopeLocation(input, { utilityContext, track }));
